/* Drives the prev/next arrows of every [data-tp-carousel]. The track itself is
   plain CSS scroll-snap, so it swipes and keyboard-scrolls with JS off; this
   only scrolls one page per click and disables an arrow at either end. */
(function () {
  if (window.tpCarouselReady) return;
  window.tpCarouselReady = true;

  function bind(root) {
    if (root.dataset.tpBound) return;
    root.dataset.tpBound = '1';
    var track = root.querySelector('.tp-track');
    var prev = root.querySelector('[data-tp-prev]');
    var next = root.querySelector('[data-tp-next]');
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function page(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-tp-carousel]').forEach(bind);
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
